import React, { useState, useEffect } from "react";
import {
  Card,
  CardBody,
  CardHeader,
} from "../../../../_metronic/_partials/controls";
import {
  Button,
  TextField,
  MuiThemeProvider,
  FormControlLabel,
  Checkbox,
  createTheme,
} from "@material-ui/core";
import { useHistory, useParams } from "react-router-dom";
import { useSkeleton } from "../../../hooks/useSkeleton";
import { alertError, alertSuccess } from "../../../../utils/logger";
import ConfirmDialog from "../../../components/dialogs/ConfirmDialog";
import { getUserTypes } from "../../../../api/userType";
import { Autocomplete } from "@material-ui/lab";
import { getCursoById, updateCurso } from "../../../../api/curso";
import MultilanguageTabBlock from "../../../components/MultilanguageTabBlock";
import ArrowBackIcon from "@material-ui/icons/ArrowBack";

// Create theme for delete button (red)
const theme = createTheme({
  palette: {
    secondary: {
      main: "#F64E60",
    },
  },
});

function getEmptyDocumento() {
  return {
    url: "",
    title: {},
    type: "",
    active: true,
  };
}

export default function EditDocumentoPage() {
  const [documento, setDocumento] = useState(getEmptyDocumento());
  const [curso, setCurso] = useState({});
  const [openConfirmDialog, setOpenConfirmDialog] = useState(false);
  const documentoId = useParams().id;
  const cursoId = useParams().cursoId;
  const history = useHistory();

  const {
    isLoading: isLoadingData,
    disableLoading: disableLoadingData,
    ContentSkeleton,
  } = useSkeleton();

  useEffect(() => {
    const fetchData = async () => {
      try {
        getCursoById(cursoId)
          .then((res) => {
            if (res.status === 200) {
              setCurso(res.data);
              if (documentoId) {
                setDocumento(
                  res.data.documentos?.find((x) => x._id === documentoId)
                );
              }

              disableLoadingData();
            }
          })
          .catch((error) => {
            alertError({
              error: error,
              customMessage: "Could not get documento.",
            });
            history.push("/cursos");
          });
      } catch (error) {}
    };
    fetchData();
  }, [cursoId, documentoId, disableLoadingData, history]);

  function handleDeleteMedia(selectedMediaId) {
    let baseArray = curso.documentos;
    let saveCurso = curso;
    let updateKey = "documentos";

    // Encontrar el elemento que se va a eliminar para obtener su orden
    const elementToDelete = baseArray.find(
      (item) => item._id === selectedMediaId
    );

    const deletedOrder = elementToDelete.order;

    // Filtrar el elemento a eliminar
    const filteredArray = baseArray.filter(
      (item) => item._id !== selectedMediaId
    );

    // Actualizar el orden de los elementos restantes
    const updatedArray = filteredArray.map((item) => {
      if (item.order > deletedOrder) {
        return {
          ...item,
          order: item.order - 1,
        };
      }
      return item;
    });

    // Actualizar el estado
    saveCurso = {
      ...saveCurso,
      [updateKey]: updatedArray,
    };

    updateCurso(cursoId, saveCurso)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: "Deleted!",
            customMessage: "Documento deleted",
          });
          history.push("/edit-curso/" + cursoId);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not save changes.",
        });
      });
  }

  const renderMultilanguageTabContent = (lang) => {
    return (
      <>
        <TextField
          id={`title`}
          label="Titulo"
          value={
            documento.title && documento.title[lang]
              ? documento.title[lang]
              : ""
          }
          onChange={handleChange("title", lang)}
          InputLabelProps={{
            shrink: true,
          }}
          margin="normal"
          variant="outlined"
          required
        />
      </>
    );
  };

  function saveDocumento() {
    let saveCurso = curso;
    let saveDocumento = documento;
    if (documentoId) {
      saveCurso = {
        ...saveCurso,
        documentos: saveCurso.documentos.map((item) =>
          item._id === documentoId ? saveDocumento : item
        ),
      };
    } else {
      if (!Array.isArray(saveCurso.documentos)) {
        saveCurso.documentos = [];
      }
      saveDocumento = { ...saveDocumento, order: saveCurso.documentos.length };
      saveCurso.documentos.push(saveDocumento);
    }

    updateCurso(cursoId, saveCurso)
      .then((res) => {
        if (res.status === 200) {
          alertSuccess({
            title: "Saved!",
            customMessage: "Changes successfully saved.",
          });
          history.push("/edit-curso/" + cursoId);
        }
      })
      .catch((error) => {
        alertError({
          error: error,
          customMessage: "Could not save changes.",
        });
      });
  }

  const renderStickyButtons = ({
    onBack,
    onSave,
    onDelete,
    setObj,
    obj,
    showDelete = false,
  }) => {
    return (
      <div
        className="sticky-top bg-white border-top shadow-sm"
        style={{
          zIndex: 1000,
          paddingLeft: "15px",
          paddingRight: "15px",
        }}
      >
        <div className="container-fluid">
          <div className="row py-3">
            <div className="col-12">
              <div className="d-flex justify-content-between align-items-center flex-wrap gap-2">
                {/* Botón Back */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onBack}
                    variant="outlined"
                    size="medium"
                    className="text-nowrap"
                    startIcon={<ArrowBackIcon />}
                  >
                    Back
                  </Button>
                </div>

                {/* Botones Save y Delete */}
                <div className="d-flex gap-2">
                  <Button
                    onClick={onSave}
                    variant="outlined"
                    color="primary"
                    style={{ marginRight: "20px" }}
                  >
                    Save
                  </Button>

                  {showDelete && (
                    <MuiThemeProvider theme={theme}>
                      <Button
                        onClick={onDelete}
                        variant="outlined"
                        color="secondary"
                        size="medium"
                        className="text-nowrap"
                      >
                        Delete
                      </Button>
                    </MuiThemeProvider>
                  )}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const handleChange = (element, lang) => (event) => {
    if (lang) {
      if (event.target.value === " ") return;

      if (!documento[element]) documento[element] = {};
      let newText = documento[element];
      newText[lang] = event.target.value;
      setDocumento({ ...documento, [element]: newText });
    } else setDocumento({ ...documento, [element]: event.target.value });
  };
  const handleChangeSelect = (element, newValue) => {
    setDocumento({ ...documento, [element]: newValue });
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      setDocumento({ ...documento, url: file });
    }
  };

  if (isLoadingData) return <ContentSkeleton />;
  else
    return (
      <>
        <Card>
          {renderStickyButtons({
            onBack: () => history.push("/edit-curso/" + cursoId),
            onSave: saveDocumento,
            onDelete: () => setOpenConfirmDialog(true),
            showDelete: !!documentoId,
            setObj: setDocumento,
            obj: documento,
          })}
          <CardHeader title="Editar Documento"></CardHeader>
          <CardBody>
            <MultilanguageTabBlock
              multilanguageTabContent={renderMultilanguageTabContent}
            />
            <div className="d-flex">
              <div className="col-md-4">
                <Autocomplete
                  className="w-100 mr-5"
                  id="autocomplete-familia"
                  options={["Público", "Privado"]}
                  value={documento.type}
                  onChange={(event, newValue) =>
                    handleChangeSelect("type", newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      margin="normal"
                      variant="outlined"
                      InputLabelProps={{
                        shrink: true,
                      }}
                      label="Seleccionar Tipo"
                    />
                  )}
                />
              </div>
              <div className="col-md-4">
                <Button variant="contained" component="label">
                  Seleccionar archivo
                  <input type="file" hidden onChange={handleFileChange} />
                </Button>
                {documento.url && (
                  <div style={{ marginTop: "10px" }}>
                    <strong>Archivo seleccionado:</strong>{" "}
                    {documento.url.name || documento.url.split("/").pop()}
                  </div>
                )}
              </div>
            </div>

            <br />
            <FormControlLabel
              control={
                <Checkbox
                  checked={documento.active}
                  onChange={() =>
                    setDocumento({ ...documento, active: !documento.active })
                  }
                  name="checkActive"
                />
              }
              label="Active"
            />
          </CardBody>
        </Card>
        {documentoId && (
          <>
            <ConfirmDialog
              title={"Are you sure you want to delete this document?"}
              open={openConfirmDialog}
              setOpen={setOpenConfirmDialog}
              onConfirm={() => {
                handleDeleteMedia(documentoId);
              }}
            />
          </>
        )}
      </>
    );
}
